import _ from "lodash";
import React, { Component } from "react";
import Draggable from "react-draggable";
import { connect } from "react-redux";
import { ComboBox } from "office-ui-fabric-react/lib-commonjs/ComboBox";
import { ChoiceGroup } from "office-ui-fabric-react/lib/ChoiceGroup";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import {
    floatingToolPipesMoved,
    floatingToolPipesClose,
    removePipeAccessory,
    setPipeAccessory,
} from "../../actions/floating-tool-pipes-actions";
import "./index.css";
import {
    PIPE_ELEMENT_TYPE_BEND,
    PIPE_ELEMENT_TYPE_STICK,
    PIPE_ELEMENT_TYPE_SINGLE_TEE,
    PIPE_ELEMENT_TYPE_DOUBLE_TEE,
    PIPE_ELEMENT_TYPE_TRIPLE_TEE,
    MSG_INVALID_CONTEXT_ELEMENT_TYPE_ERROR,
    PIPE_POSITION_LEFT,
    PIPE_POSITION_CENTER,
    PIPE_POSITION_RIGHT,
    PIPE_SIDE_TOP,
    PIPE_SIDE_SIDE,
    PIPE_SIDE_RIGHT,
    PIPE_SIDE_LEFT,
    PIPE_ACCESSORY_RISER,
    PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    PIPE_ACCESSORY_STUB_CONCENTRIC,
    PIPE_ACCESSORY_STUB_CROWN_MATCHING,
    PIPE_ACCESSORY_CLEANOUT_LEFT,
    PIPE_ACCESSORY_CLEANOUT,
    PIPE_ACCESSORY_CLEANOUT_RIGHT,
    PIPE_ACCESSORY_INSERTA_TEE,
    GLOBAL_PROJECT_TYPE_PIPE,
    PIPE_BED_UPPER_MANIFOLD,
    PIPE_BED_LOWER_MANIFOLD,
    PIPE_FLOW_BASIN_POSITION,
    PIPE_FLOW_BASIN_SHAPE_TYPE,
    PIPE_ACCESSORY_ROUND_BASIN,
    PIPE_ACCESSORY_SQUARE_BASIN,
} from "../../lib/types";
import PipeElement from "../../lib/pipe-element";
import {
    accessoryRiserSizeMatrix,
    accessoryCleanOutSizeMatrix,
    accessorySizesMap,
    accessoryMaxSizesMap,
    mutualExclusiveMaps,
    sizingExceptionMap,
    exceptionMap,
} from "../../lib/accessories.js";
import PopUpHelper from "../Calculations/popUpHelper.component";
import {
    setPipeFlowDirection,
} from "../../actions/pipe-bed-actions";

/* the pipes components images */
const pipeBendImg = require("../../media/pipe-bend-floating-tool.png");
const pipeBendTopImg = require("../../media/pipe-bend-top-floating-tool.png");
const pipeBendRightImg = require("../../media/pipe-bend-right-floating-tool.png");
const pipeBendLeftImg = require("../../media/pipe-bend-left-floating-tool.png");
const pipeStickImg = require("../../media/pipe-stick-floating-tool.png");
const pipeStickTopImg = require("../../media/pipe-stick-top-floating-tool.png");
const pipeStickRightImg = require("../../media/pipe-stick-right-floating-tool.png");
const pipeStickLeftImg = require("../../media/pipe-stick-left-floating-tool.png");
const pipeTeeImg = require("../../media/pipe-tee-floating-tool.png");
const pipeTeeTopImg = require("../../media/pipe-tee-top-floating-tool.png");
const pipeTeeSidepImg = require("../../media/pipe-tee-side-floating-tool.png");
const choiceGroupSize = { width: 32, height: 32 };
const accessoryPlacementTee = {  //tee compatible accessories
    [PIPE_SIDE_TOP]: [
        PIPE_ACCESSORY_RISER,
        PIPE_ACCESSORY_CLEANOUT,
    ],
    [PIPE_SIDE_SIDE]: [
        PIPE_ACCESSORY_INSERTA_TEE,
        PIPE_ACCESSORY_STUB_CROWN_MATCHING,
        PIPE_ACCESSORY_STUB_CONCENTRIC,
        PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    ],
    "opposites": {
        [PIPE_SIDE_TOP]: [PIPE_SIDE_SIDE],
        [PIPE_SIDE_SIDE]: [PIPE_SIDE_TOP],
    },
};
const accessoryPlacementStick = { // stick compatible accessories
    [PIPE_SIDE_TOP]: [
        PIPE_ACCESSORY_RISER,
    ],
    [PIPE_SIDE_LEFT]: [
        PIPE_ACCESSORY_INSERTA_TEE,
        PIPE_ACCESSORY_STUB_CROWN_MATCHING,
        PIPE_ACCESSORY_STUB_CONCENTRIC,
        PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    ],
    [PIPE_SIDE_RIGHT]: [
        PIPE_ACCESSORY_INSERTA_TEE,
        PIPE_ACCESSORY_STUB_CROWN_MATCHING,
        PIPE_ACCESSORY_STUB_CONCENTRIC,
        PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    ],
    "opposites": {
        [PIPE_SIDE_TOP]: [PIPE_SIDE_LEFT, PIPE_SIDE_RIGHT],
        [PIPE_SIDE_LEFT]: [PIPE_SIDE_TOP],
        [PIPE_SIDE_RIGHT]: [PIPE_SIDE_TOP],
    },
};
const accessoryPlacementBend = { // stick compatible accessories */
    [PIPE_SIDE_TOP]: [
        PIPE_ACCESSORY_RISER,
        PIPE_ACCESSORY_CLEANOUT_LEFT,
        PIPE_ACCESSORY_CLEANOUT_RIGHT,
    ],
    [PIPE_SIDE_LEFT]: [
        PIPE_ACCESSORY_INSERTA_TEE,
        PIPE_ACCESSORY_STUB_CROWN_MATCHING,
        PIPE_ACCESSORY_STUB_CONCENTRIC,
        PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    ],
    [PIPE_SIDE_RIGHT]: [
        PIPE_ACCESSORY_INSERTA_TEE,
        PIPE_ACCESSORY_STUB_CROWN_MATCHING,
        PIPE_ACCESSORY_STUB_CONCENTRIC,
        PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    ],
    "opposites": {
        [PIPE_SIDE_TOP]: [PIPE_SIDE_LEFT, PIPE_SIDE_RIGHT],
        [PIPE_SIDE_LEFT]: [PIPE_SIDE_TOP],
        [PIPE_SIDE_RIGHT]: [PIPE_SIDE_TOP],
    },
};
const defaultState = {
    position: PIPE_POSITION_CENTER,
    placement: PIPE_SIDE_TOP,
    showConfirmation: false,
};

class FloatingToolPipes extends Component{
    state = defaultState;

    componentDidUpdate( prevProps ) {
        /* if a different element is selected and positioning in state is not compatible, reset */
        if (this.anyPropHasChanged(prevProps, ["selected"])
        ) {
            this.setState(defaultState);
        }
    }

    /**
     * This method receives the previous properties object and an Array of
     * the properties to be determined if have changed and returns true if any
     * have changed, or false if all are the same.
     * @param {Object} prevProps The previous properties of the component.
     * @param {Array<string>} propNames The Properties names array.
     */
    anyPropHasChanged( prevProps, propNames ) {
        let changed = false;
        for (let name of propNames) {
            changed = this.props[name] !== prevProps[name] || changed;
        }
        return changed;
    }

    render() {
        const {
            x,
            y,
            lang,
            content,
            selected,
            projectType,
            pipeElements,
            selectedDiameter,
            numberOfPipeRows,
            setPipeAccessory,
            removePipeAccessory,
            pipeNominalDiameter,
            floatingToolPipesMoved,
            floatingToolPipesClose,
        } = this.props;

        if (selected && projectType === GLOBAL_PROJECT_TYPE_PIPE) {

            const handleDragStop = ( event, node ) => {
                if (x !== node.x || y !== node.y) {
                    floatingToolPipesMoved(node.x, node.y);
                }
            };

            const renderToolContent = () => {
                /* find the element first, or create new instance */
                let element = pipeElements.find(( e ) => {
                    return _.isEqual(e.id, selected);
                }) || new PipeElement(selected, selected.type);
                /* the tool dynamic body render */
                let body;
                /* set the default position if needed */
                if (!element.placeholders[this.state.position]) {
                    this.setState({
                        position: Object.keys(element.placeholders)[0],
                    });
                    return <div/>;
                }

                /* decide witch body to render depending on targetType */
                switch (element.type) {
                    case PIPE_ELEMENT_TYPE_STICK:
                        body = renderPipeStickTools(element);
                        break;
                    case PIPE_ELEMENT_TYPE_BEND:
                        body = renderPipeBendTools(element);
                        break;
                    case PIPE_ELEMENT_TYPE_SINGLE_TEE:
                    case PIPE_ELEMENT_TYPE_DOUBLE_TEE:
                    case PIPE_ELEMENT_TYPE_TRIPLE_TEE:
                        body = renderPipesTeeTools(element);
                        break;
                    default:
                        throw new Error(MSG_INVALID_CONTEXT_ELEMENT_TYPE_ERROR);
                }
                /* render the floating tools */
                return (
                    <div className="FLoatingToolPipes">
                        <div className="handle">
              <span className="closeButtom" onClick={floatingToolPipesClose}>
                X
              </span>
                        </div>
                        {body}
                    </div>
                );
            };

            const renderPipeStickTools = ( element ) => {

                /* the template options */
                /* the template options */
                let positionOptions = [
                    {
                        key: PIPE_POSITION_CENTER,
                        imageSrc: pipeStickImg,
                        selectedImageSrc: pipeStickImg,
                        imageSize: choiceGroupSize,
                        text: content[lang][PIPE_POSITION_CENTER],
                    },
                ];

                /* the template options */
                let placementOptions = [];

                if (element.id.row === 0) {
                    placementOptions.push({
                        imageSrc: pipeStickLeftImg,
                        selectedImageSrc: pipeStickLeftImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_LEFT,
                        text: content[lang][PIPE_SIDE_LEFT],
                    });
                }
                /* always render the center positioning */
                placementOptions.push({
                    imageSrc: pipeStickTopImg,
                    selectedImageSrc: pipeStickTopImg,
                    imageSize: choiceGroupSize,
                    key: PIPE_SIDE_TOP,
                    text: content[lang][PIPE_SIDE_TOP],
                });

                if (element.id.row === numberOfPipeRows - 1) {
                    placementOptions.push({
                        imageSrc: pipeStickRightImg,
                        selectedImageSrc: pipeStickRightImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_RIGHT,
                        text: content[lang][PIPE_SIDE_RIGHT],
                    });
                }

                return renderPositionAndPlacementSelection(
                    element,
                    accessoryPlacementStick,
                    positionOptions,
                    placementOptions,
                    content[lang].selectPipeStickPosition,
                );
            };

            const renderPipeBendTools = ( element ) => {
                /* the template options */
                let positionOptions = [
                    {
                        key: PIPE_POSITION_CENTER,
                        imageSrc: pipeBendImg,
                        selectedImageSrc: pipeBendImg,
                        imageSize: choiceGroupSize,
                        text: content[lang][PIPE_POSITION_CENTER],
                    },
                ];

                /* the template options */
                let placementOptions = [
                    {
                        imageSrc: pipeBendLeftImg,
                        selectedImageSrc: pipeBendLeftImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_LEFT,
                        text: content[lang][PIPE_SIDE_LEFT],
                    },
                    {
                        imageSrc: pipeBendTopImg,
                        selectedImageSrc: pipeBendTopImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_TOP,
                        text: content[lang][PIPE_SIDE_TOP],
                    },
                    {
                        imageSrc: pipeBendRightImg,
                        selectedImageSrc: pipeBendRightImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_RIGHT,
                        text: content[lang][PIPE_SIDE_RIGHT],
                    },
                ];
                return renderPositionAndPlacementSelection(
                    element,
                    accessoryPlacementBend,
                    positionOptions,
                    placementOptions,
                    content[lang].selectPipeBendPosition,
                );
            };

            const renderPipesTeeTools = ( element ) => {
                /* the choicegroup template */
                let teePositioningOptionTemplate = {
                    imageSrc: pipeTeeImg,
                    selectedImageSrc: pipeTeeImg,
                    imageSize: choiceGroupSize,
                };
                /* the template options */
                let positionOptions = [
                    {
                        ...teePositioningOptionTemplate,
                        key: PIPE_POSITION_LEFT,
                        text: content[lang][PIPE_POSITION_LEFT],
                    },
                    {
                        ...teePositioningOptionTemplate,
                        key: PIPE_POSITION_CENTER,
                        text: content[lang][PIPE_POSITION_CENTER],
                    },
                    {
                        ...teePositioningOptionTemplate,
                        key: PIPE_POSITION_RIGHT,
                        text: content[lang][PIPE_POSITION_RIGHT],
                    },
                ];
                /* the template options */
                let placementOptions = [
                    {
                        imageSrc: pipeTeeTopImg,
                        selectedImageSrc: pipeTeeTopImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_TOP,
                        text: content[lang][PIPE_SIDE_TOP],
                    },
                    {
                        imageSrc: pipeTeeSidepImg,
                        selectedImageSrc: pipeTeeSidepImg,
                        imageSize: choiceGroupSize,
                        key: PIPE_SIDE_SIDE,
                        text: content[lang][PIPE_SIDE_SIDE],
                    },
                ];

                switch (element.type) {
                    case PIPE_ELEMENT_TYPE_TRIPLE_TEE:
                        break;
                    case PIPE_ELEMENT_TYPE_DOUBLE_TEE:
                        positionOptions.splice(1, 1);
                        break;
                    case PIPE_ELEMENT_TYPE_SINGLE_TEE:
                        positionOptions.splice(0, 1);
                        positionOptions.splice(1, 1);
                        break;
                    default:
                        break;
                }

                let teeAmnt = ( () => {
                    switch (positionOptions.length) {
                        case 1:
                            return content[lang].single;
                        case 2:
                            return content[lang].double;
                        case 3:
                            return content[lang].triple;
                        default:
                            break;
                    }
                } )();

                return renderPositionAndPlacementSelection(
                    element,
                    accessoryPlacementTee,
                    positionOptions,
                    placementOptions,
                    `${content[lang].select} ${teeAmnt} ${content[lang].teePosition}`,
                );
            };

            const renderPositionAndPlacementSelection = ( element, placementObj, positionOptions, placementOptions, label ) => {
                return <React.Fragment>
                    <div className="chamberFloatingOptions">
                        {
                            ( () => {
                                if (element["type"] === PIPE_ELEMENT_TYPE_BEND) {
                                    return ( <React.Fragment>
                                        <PrimaryButton text={content[lang].setFlowDirection} onClick={handleSetFlowDirection}/>
                                        &nbsp;
                                        <div className="popup-helper">
                                            <PopUpHelper
                                                text={content[lang].clickSetFlowDirection}
                                                title={content[lang].setFlowDirection}
                                            />
                                        </div>
                                        <br/><br/>
                                        <span>{content[lang].basin}</span>
                                        <hr/>
                                        <PrimaryButton text={content[lang].round}
                                                       onClick={() => setBasin(element, PIPE_FLOW_BASIN_SHAPE_TYPE.ROUND)}/>
                                        &nbsp;
                                        <PrimaryButton text={content[lang].square}
                                                       onClick={() => setBasin(element, PIPE_FLOW_BASIN_SHAPE_TYPE.SQUARE)}/>
                                        &nbsp;
                                        <PrimaryButton text={content[lang].none}
                                                       onClick={() => setBasin(element, PIPE_FLOW_BASIN_SHAPE_TYPE.NONE)}/>
                                        <br/><br/>
                                    </React.Fragment> );
                                }
                            } )()
                        }
                        {!hasBasin(element) ?
                            ( <React.Fragment>
                                <span>{label}</span>
                                <hr/>
                                <ChoiceGroup
                                    className={"positionChoiceGroup"}
                                    selectedKey={this.state.position}
                                    options={positionOptions}
                                    onChange={( evt, option ) => {
                                        /* update current state */
                                        this.setState({ position: option.key });
                                    }}
                                />
                                <br/>
                                <span>{content[lang].selectPlacement}</span>
                                <hr/>
                                <ChoiceGroup
                                    className={"placementChoiceGroup"}
                                    selectedKey={this.state.placement}
                                    options={placementOptions}
                                    onChange={( evt, option ) => {
                                        /* update current state */
                                        this.setState({ placement: option.key });
                                    }}
                                />
                                <br/>
                                <span>{content[lang].accessory}</span>
                                <hr/>
                                {renderAccessorySelection(
                                    element,
                                    placementObj[this.state.placement],
                                    placementObj.opposites[this.state.placement],
                                )}
                            </React.Fragment> ) : null}
                    </div>
                </React.Fragment>;
            };

            const renderAccessorySelection = ( element, accessoryList, opposites ) => {
                if (!accessoryList || !opposites) {
                    this.setState(defaultState);
                    return;
                }
                /* the matrix element */
                let placement = this.state.placement;
                let diameter = selectedDiameter ? selectedDiameter.rawPipeND : 0;
                let accsrSel = element.placeholders[this.state.position][this.state.placement];
                let oppositeSelections = opposites.map(( opposite ) => {
                    let obj = element.placeholders[this.state.position][opposite];
                    if (obj) {
                        return {
                            ...obj,
                            position: opposite,
                        };
                    } else {
                        return obj;
                    }
                }).filter(a => a);

                /* building the accessory list */
                accessoryList = accessoryList.map(a => {
                    return {
                        text: parseAccessoryName(a),
                        key: a,
                    };
                });

                let exceptionMapAcc = exceptionMap;
                let sizingExceptionMapAcc = sizingExceptionMap;

                /* clean up mutual exclusive accessorries */
                if (oppositeSelections.length) {
                    /* clean collisions first */
                    accessoryList = accessoryList.filter(( listItem ) => {
                        return !oppositeSelections.some(( opposite ) => {
                            return mutualExclusiveMaps.some(( mutualExclusive ) => {
                                /* EXCEPTION, put CROWN MATCHING STUB back if it is a bend and cleanout is in the opposite */
                                let except = exceptionMapAcc.some(( exMap ) => {
                                    return exMap[placement] && exMap[listItem.key] && exMap[opposite.type] && exMap[opposite.position];
                                });

                                if (except) {
                                    return false;
                                }
                                /* created for the concentric stubs and Inserta tee on pipe diameters larger than or equal than 24" */
                                let exceptSizing = sizingExceptionMapAcc.some(( sizeExMap ) => {
                                    console.log(`Sizing Rule: ${listItem.key}, ${opposite.type}, ${sizeExMap.minSize}, ${sizeExMap[placement]}`);
                                    // return (sizeExMap[opposite.position] && sizeExMap[listItem.key] && sizeExMap[opposite.type] && sizeExMap[placement]) && diameter < sizeExMap.minSize;
                                    return ( sizeExMap[listItem.key] && sizeExMap[opposite.type] && sizeExMap[placement] ) && diameter < sizeExMap.minSize;
                                });

                                /* if accessory in list and opposite selection are mutual exclusive, remove */
                                return ( mutualExclusive[listItem.key] && mutualExclusive[opposite.type] ) || exceptSizing;
                            });
                        });
                    });
                }

                /* push the default accessory */
                accessoryList.unshift({ key: "none", text: this.props.content[this.props.lang].none });

                let accessorySizeList = ( accsrSel ) ? accessorySizesMap[accsrSel.type] : [];
                console.log(accessoryMaxSizesMap, ( accsrSel ) ? accsrSel.type : "");

                /* Size filter #1: removing sizes based on part size */
                let maxAccessorySize = ( accsrSel ) ? accessoryMaxSizesMap[accsrSel.type][diameter] : 0;
                /* this boolean will trucate sizes according to the sizing rules, this is currently
                applied to cleanouts and concentric stubs or inserta tees */
                let applyCleanOutRules = false;
                if (accsrSel) {
                    applyCleanOutRules = sizingExceptionMapAcc.some(( sizeExMap ) => {
                        return oppositeSelections.some(( opposite ) => {
                            return ( sizeExMap[opposite.type] && sizeExMap[accsrSel.type] ) && diameter >= sizeExMap.minSize;
                        });
                    });
                }

                /* limit the sizes according to the rules */
                accessorySizeList = accessorySizeList.filter(s => s <= maxAccessorySize);

                /* the rules sizing*/
                let sizesRuleSet = null;
                /* the opposite message rule */
                let oppositeExceptionMsg = null;
                /* size filter #2, if there are opposite selections filter out */
                if (oppositeSelections.length) {
                    sizesRuleSet = oppositeSelections.map(( opposite ) => {
                        let rules;
                        if (applyCleanOutRules) {
                            rules = accessoryCleanOutSizeMatrix[diameter];
                        } else {
                            rules = accessoryRiserSizeMatrix[diameter];
                        }

                        /* if cleanout is pointing in the opposite direction, it does not apply anyways */
                        if (applyCleanOutRules &&
                            !opposite.type.toLocaleLowerCase().includes(this.state.placement) &&
                            this.state.placement !== "top" &&
                            opposite.position !== "side" &&
                            this.state.placement !== "side"
                        ) {
                            /* overwrite rules */
                            rules = accessoryRiserSizeMatrix[diameter];
                        }

                        /* prevent selection if size does not apply to a cleanout that is pointing on the opposite direction */
                        if (accsrSel &&
                            applyCleanOutRules &&
                            !rules[opposite.size].length &&
                            ( accsrSel.type.toLocaleLowerCase().includes(opposite.position) || opposite.position === "side" )
                        ) {
                            /* it does not fit */
                            oppositeExceptionMsg = [
                                `There is a ${opposite.type.toLocaleLowerCase().substr(15)} of ${opposite.size}in. `,
                                `attached on the ${opposite.position} which prevents a ${accsrSel.type.toLocaleLowerCase().substr(15)} from being selected. `,
                                `Try to lower the size of the ${opposite.type.toLocaleLowerCase().substr(15)}.`,
                            ].join("");
                        }
                        /* return the rule sizes for this combination */
                        let r = rules;
                        let sizes = [];

                        /* if row wise( see tables in memo 60 )*/
                        switch (opposite.type) {
                            case PIPE_ACCESSORY_STUB_INVERT_MATCHING:
                            case PIPE_ACCESSORY_STUB_CONCENTRIC:
                            case PIPE_ACCESSORY_STUB_CROWN_MATCHING:
                            case PIPE_ACCESSORY_INSERTA_TEE:
                                sizes = r[opposite.size] || [];
                                break;
                            case PIPE_ACCESSORY_RISER:
                            case PIPE_ACCESSORY_CLEANOUT:
                            case PIPE_ACCESSORY_CLEANOUT_LEFT:
                            case PIPE_ACCESSORY_CLEANOUT_RIGHT:

                                /* get the column index */
                                let colIdx = Object.keys(r).indexOf(`${opposite.size}`);
                                for (let rowSize in r) {
                                    let itFits = r[rowSize][colIdx];
                                    if (itFits) {
                                        sizes.push(parseInt(rowSize, 10));
                                    }
                                }
                                break;
                            default:
                                break;
                        }

                        /* return this size rules */
                        return sizes;
                    });

                    if (sizesRuleSet.length) {
                        /* remove arrays with 0 elements */
                        sizesRuleSet = sizesRuleSet.filter(( ruleArr ) => ruleArr.length > 0);
                        /* intersect all sizes array to constraint the sizes */
                        accessorySizeList = _.intersection(...sizesRuleSet, accessorySizeList);
                    }
                }

                /* transform accessory size selection */
                accessorySizeList = accessorySizeList.map(a => {
                    return {
                        text: `${a}in.`,
                        key: a,
                    };
                });
                /* if it cannot be placed, remove it */
                if (oppositeExceptionMsg) {
                    /* show the message and reset accessory */
                    this.setState({
                        showConfirmation: true,
                        message: oppositeExceptionMsg,
                    });
                    /* reset the accessory */
                    removePipeAccessory(element.id, this.state.position, this.state.placement);
                }

                /* render the accessory and size options */
                return (
                    <div className="row">
                        <div className="accessoryColumn">
                            <ComboBox
                                selectedKey={( accsrSel ) ? accsrSel.type : "none"}
                                id="accessory"
                                ariaLabel="pipe accessory"
                                options={accessoryList}
                                onChanged={value => {

                                    console.log("Selecting accessory to", value.key, "at", this.state.position, this.state.placement, element.id);
                                    if (sizesRuleSet != null && sizesRuleSet.size === 0) {
                                        this.setState({
                                            showConfirmation: true,
                                            message: `The accessory '${value.text}' does not fit in here because a larger accessory is attached in other side of the same position.`,
                                        });
                                    } else if (value.key === "none") {
                                        /* removing accessory */
                                        removePipeAccessory(element.id, this.state.position, this.state.placement);
                                    } else {
                                        let size = accessorySizesMap[value.key][0];
                                        /* change accessory here */
                                        setPipeAccessory(element.id, this.state.position, this.state.placement, value.key, size);
                                    }
                                }}
                            />
                        </div>
                        {
                            ( () => {
                                if (accsrSel) {
                                    return (
                                        <div className="accessorySizeColumn">
                                            <ComboBox
                                                selectedKey={( accsrSel ) ? accsrSel.size : null}
                                                id="accessorySize"
                                                ariaLabel="pipe accessory size"
                                                options={accessorySizeList}
                                                onChanged={value => {
                                                    /* change accessory size along type */
                                                    setPipeAccessory(element.id, this.state.position, this.state.placement, accsrSel.type, value.key);
                                                }}
                                            />
                                        </div>
                                    );
                                }
                            } )()
                        }
                    </div>
                );
            };

            const parseAccessoryName = ( name ) => {
                let clean = name.replace("PIPE_ACCESSORY_", "").split("_").join("").toLowerCase();
                let localized = content[lang][clean];
                return localized;
            };

            const handleSetFlowDirection = () => {
                const currentSelection = getCurrentSelection();

                switch (currentSelection) {
                    case PIPE_FLOW_BASIN_POSITION.TOP_LEFT:
                    case PIPE_FLOW_BASIN_POSITION.BOTTOM_LEFT:
                    case PIPE_FLOW_BASIN_POSITION.TOP_RIGHT:
                    case PIPE_FLOW_BASIN_POSITION.BOTTOM_RIGHT:
                        this.props.setPipeFlowDirection(currentSelection);
                        break;
                    default:
                        break;
                }
            };

            const getCurrentSelection = () => {
                let currentSel = null;
                if (this.props.selected.index === 0 && this.props.selected.section === PIPE_BED_UPPER_MANIFOLD) {
                    currentSel = PIPE_FLOW_BASIN_POSITION.TOP_LEFT;
                }
                if (this.props.selected.index === 0 && this.props.selected.section === PIPE_BED_LOWER_MANIFOLD) {
                    currentSel = PIPE_FLOW_BASIN_POSITION.BOTTOM_LEFT;
                }
                if (this.props.selected.index !== 0 && this.props.selected.section === PIPE_BED_UPPER_MANIFOLD) {
                    currentSel = PIPE_FLOW_BASIN_POSITION.TOP_RIGHT;
                }
                if (this.props.selected.index !== 0 && this.props.selected.section === PIPE_BED_LOWER_MANIFOLD) {
                    currentSel = PIPE_FLOW_BASIN_POSITION.BOTTOM_RIGHT;
                }
                return currentSel;
            };

            const setBasin = ( element, type ) => {
                // const self = this;
                const resetAccessories = () => {
                    pipeElements
                        .filter(pipeElement => pipeElement.id === element.id)
                        .forEach(pipeElement => {
                            removePipeAccessory(pipeElement.id, PIPE_POSITION_CENTER, PIPE_SIDE_TOP);
                            removePipeAccessory(pipeElement.id, PIPE_POSITION_CENTER, PIPE_SIDE_LEFT);
                            removePipeAccessory(pipeElement.id, PIPE_POSITION_CENTER, PIPE_SIDE_RIGHT);
                        });
                };

                switch (type) {
                    case PIPE_FLOW_BASIN_SHAPE_TYPE.ROUND:
                        resetAccessories();
                        return setPipeAccessory(element.id, PIPE_POSITION_CENTER, PIPE_SIDE_TOP, PIPE_ACCESSORY_ROUND_BASIN, pipeNominalDiameter.rawPipeND);
                    case PIPE_FLOW_BASIN_SHAPE_TYPE.SQUARE:
                        resetAccessories();
                        return setPipeAccessory(element.id, PIPE_POSITION_CENTER, PIPE_SIDE_TOP, PIPE_ACCESSORY_SQUARE_BASIN, pipeNominalDiameter.rawPipeND);
                    case PIPE_FLOW_BASIN_SHAPE_TYPE.NONE:
                        if (hasBasin(element)) {
                            return removePipeAccessory(element.id, PIPE_POSITION_CENTER, PIPE_SIDE_TOP);
                        }
                        break;
                    default:
                        break;
                }
            };

            const hasBasin = ( element ) => {
                return pipeElements.some(pipeElement => {
                    try {
                        return ( pipeElement.id === element.id &&
                            ( pipeElement.placeholders.center.top.type === PIPE_ACCESSORY_ROUND_BASIN ||
                                pipeElement.placeholders.center.top.type === PIPE_ACCESSORY_SQUARE_BASIN ) );
                    } catch (exception) {
                        return false;
                    }
                });
            };

            return (
                <div>
                    <Draggable
                        onStop={handleDragStop.bind(this)}
                        bounds="#layout"
                        handle=".handle"
                        position={{ x: x, y: y }}
                    >
                        {renderToolContent()}
                    </Draggable>
                    <PopUpHelper
                        title={content[lang].ok}
                        type="alert"
                        modalActions={() => {
                            this.setState({ showConfirmation: false });
                        }}
                        show={this.state.showConfirmation}
                        hideModal={() => {
                            this.setState({ showConfirmation: false });
                        }}
                        text={this.state.message}
                    />
                </div>
            );
        } else {
            return <span style={{ display: "none" }}/>;
        }
    }
}

const mapStateToProps = state => {
    return {
        x: state.floatingtoolpipes.x,
        y: state.floatingtoolpipes.y,
        lang: state.localization.lang,
        content: state.localization.content,
        /* the global properties */
        selected: state.pipeGlobals.contextSelectedPipeElement,
        /* the diameter */
        selectedDiameter: state.pipeGlobals.pipeNominalDiameter,
        /* the pipe bed elements */
        pipeElements: state.pipeBed.pipeElements,
        pipeNominalDiameter: state.pipeGlobals.pipeNominalDiameter,
        /* to hide floating tool if using chambers */
        projectType: state.globals.projectType,
        numberOfPipeRows: state.pipeBed.numberOfPipeRows,
        pipeFlowOutletPosition: state.pipeBed.pipeFlowOutletPosition,
        pipeFlowInletPosition: state.pipeBed.pipeFlowInletPosition,
    };
};

const mapDispatchToProps = {
    setPipeAccessory,
    removePipeAccessory,
    setPipeFlowDirection,
    floatingToolPipesMoved,
    floatingToolPipesClose,
};

/* export this contained component */
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FloatingToolPipes);



// WEBPACK FOOTER //
// ./src/components/FloatingToolPipes/index.js